import CustomLoader from "./components/CustomLoader";
import CustomToaster from "./components/CustomToaster";
import DiscardModal from "./components/DiscardModal";
import { ErrorScreenDesktop } from "./components/ErrorScreenDesktop";
import FAQContainer from "./components/FAQContainer";
import Footer from "./components/Footer";
import FooterMobile from "./components/FooterMobile";
import Layout from "./components/Layout";
import LayoutDescription from "./components/LayoutDescription"
import SocialMediaModal from "./components/SocialMediaModal/SocialMediaModal";
import { ColorCodes } from "./constants/ColorCodes";
import { ErrorMessages, Errors } from "./constants/ErrorMessages";
import { MixPanelEventName } from "./constants/MixPanelEventName";
import { PathName } from "./constants/PathName";
import { ScreenSize } from "./constants/ScreenSize";
import { SocialMediaInfo } from "./constants/SocialMediaList";
import { ENV_STAGES } from "./constants/Stages";
import { ErrorFallbackpage } from "./errorPages/ErrorFallbackPage";
import PreLoginLandingPage from "./errorPages/PreLoginLandingPage";
import { commonUnityStore } from "./store/CommonUnityStore";
import { IAllCategoriesResponse, ICategoryResponse, ICategoryResponseList } from "./types/Categories.types";
import MixPanel from "./utils/MixPanelConfig";
import { Links } from "./utils/MixpanelLinks";
import { awsRumConfig } from "./utils/RumConfig";
import { handleGetFullAddress, handleViewCategories } from "./utils/StoreDetailsInfo";
import { getFeatureFlagStatus } from "./api/AppConfig";
import { RedirectionLinks } from "./constants/RedirectionLinks";
import { handleEnableChat } from "./constants/Footer";
import { ConstraintLoader } from "./components/ConstraintLoader";
import { initMetaPixel , trackPixelEvent} from "./utils/MetaPixelUtils";

const { handleOpenToaster, toasterData, handleOnCloseToaster, handleChangeDiscardModal } = commonUnityStore;

export {
  awsRumConfig,
  ColorCodes,
  commonUnityStore,
  CustomLoader,
  CustomToaster,
  DiscardModal,
  ENV_STAGES,
  ErrorFallbackpage,
  ErrorMessages,
  Errors,
  ErrorScreenDesktop,
  FAQContainer,
  Footer,
  FooterMobile,
  handleChangeDiscardModal,
  handleGetFullAddress,
  handleOnCloseToaster,
  handleOpenToaster,
  handleViewCategories,
  Layout,
  LayoutDescription,
  Links,
  MixPanel,
  MixPanelEventName,
  PathName,
  PreLoginLandingPage,
  ScreenSize,
  SocialMediaInfo,
  SocialMediaModal,
  toasterData,
  getFeatureFlagStatus,
  handleEnableChat,
  RedirectionLinks,
  ConstraintLoader,
  initMetaPixel,
  trackPixelEvent,
};

export { type IAllCategoriesResponse, type ICategoryResponse, type ICategoryResponseList };
export * from "./constants/ErrorHandling";
export * from "./constants/FeatureFlags";
export * from "./MicroFrontend.index"
export * from "./types/Products.types";
export * from "./utils/ProductUtils";
export * from "./utils/SEOUtils";
export * from "./utils/CommonUtils";